export const SUCCESS_STATUS = {
  ADD_TO_FAVORITES: "اطلاعات  مورد نظر به علاقمندی‌ها اضافه شد.",
  ADD_STOCK: "سهم با موفقیت اضافه شد",
  REMOVE_FROM_FAVORITES: "اطلاعات مورد نظر حذف شد.",
  LOGIN: "کاربر با موفقیت وارد شد.",
  CREATE: "اطلاعات با موفقیت ثبت شد.",
  UPDATE: "اطلاعات با موفقیت بروزرسانی شد.",
  UPLOAD: "فایل مورد نظر با موفقیت آپلود شد.",
  REGISTER: "کاربر با موفقیت ساخته شد.",
  SEND_TICKET: "تیکت شما با موفقیت ثبت شد.",
};

export const ERROR_STATUS = {
  SERVER: "خطایی در سرور رخ داده است.",
  LOGIN: "کاربری با این اطلاعات وجود ندارد.",
  AUTH: "خطا در احراز هویت",
  INCOMPLETE: "اطلاعات وارد شده صحیح نمی باشد.",
  UPLOAD: "خطایی در آپلود اطلاعات رخ داده است.",
  AUTHORIZE: "شما مجاز به تغییرات نیستید.",
  NOTFOUND: "با توجه به پارامترهای ورودی، نتیجه‌ای یافت نشد",
  REPEAT: "پارامترهای انتخابی قبلا در لیست ثبت شده است",
  DEFAULT: "خطای ناشناخته رخ داده است.",
  INPUT: "نام داده شده نامعتبر است",
  REPEAT_STOCK: "این سهم قبلا ثبت شده است",
  USER_EXIST: "کاربر با این مشخصات وجود دارد.",
  USER_TIMEOUT: "لطفا بعد از یک دقیقه مجددا اقدام فرمایید.",
  RECAPTCHA: "لطفا چک باکس کپچا را بررسی کنید.",
  MAXIMUM_AMOUNT: "شما به حداکثر رسیدید.",
  SET_SETTING: "لطفا حداقل یک تنظیمات برای خود انتخاب کنید",
  WRONG_CODE: "کد وارد شده اشتباه است",
  FORBIDDEN: "اکانت شما مسدود شده است، لطفا با پشتیبانی تماس بگیرید.",
  USER_NOTFOUND: "اطلاعات نامعتبر است",
  SUBSCRIPTION: "شما اشتراک ندارید، برای خرید به پروفایل خود مراجعه نمایید.",
};
